import { Link } from 'react-router-dom';

export default function AboutSection() {
  return (
    <section className="px-6 md:px-10 py-12 md:py-20 bg-background-100/60">
      <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 md:gap-16">
        <div className="lg:w-1/2 flex flex-col gap-6">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 leading-tight">
            Por que usar o<br />
            CSSBuy Spreadsheet?
          </h2>
          <p className="text-foreground-600 text-base leading-relaxed max-w-lg">
            O CSSBuy Spreadsheet &eacute; uma das formas mais eficientes de encontrar produtos da China com pre&ccedil;os 
            acess&iacute;veis. Nossa plataforma organiza milhares de itens em planilhas atualizadas, facilitando 
            sua busca por streetwear, sneakers, acess&oacute;rios e muito mais. Com fotos reais de controle de 
            qualidade (QC) e links diretos para os melhores vendedores.
          </p>

          <div className="grid grid-cols-2 gap-4 mt-2">
            <div className="bg-background-50 rounded-2xl p-5 border border-background-200/60">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 mb-3">
                <i className="ri-price-tag-3-line text-accent-600 text-lg"></i>
              </div>
              <h4 className="font-semibold text-foreground-900 text-sm whitespace-nowrap">Pre&ccedil;o Baixo</h4>
              <p className="text-foreground-500 text-xs mt-1">Produtos diretamente da China com margens reduzidas</p>
            </div>
            <div className="bg-background-50 rounded-2xl p-5 border border-background-200/60">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-100 mb-3">
                <i className="ri-stack-line text-secondary-600 text-lg"></i>
              </div>
              <h4 className="font-semibold text-foreground-900 text-sm whitespace-nowrap">Variedade</h4>
              <p className="text-foreground-500 text-xs mt-1">Milhares de itens atualizados em categorias diversas</p>
            </div>
            <div className="bg-background-50 rounded-2xl p-5 border border-background-200/60">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 mb-3">
                <i className="ri-camera-line text-primary-600 text-lg"></i>
              </div>
              <h4 className="font-semibold text-foreground-900 text-sm whitespace-nowrap">Qualidade QC</h4>
              <p className="text-foreground-500 text-xs mt-1">Fotos reais dos produtos antes do envio internacional</p>
            </div>
            <div className="bg-background-50 rounded-2xl p-5 border border-background-200/60">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 mb-3">
                <i className="ri-links-line text-accent-600 text-lg"></i>
              </div>
              <h4 className="font-semibold text-foreground-900 text-sm whitespace-nowrap">F&aacute;cil Uso</h4>
              <p className="text-foreground-500 text-xs mt-1">Links organizados em planilhas prontas para usar</p>
            </div>
          </div>

          <Link
            to="/cssbuy-spreadsheet-2026"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-secondary-500 text-white hover:bg-secondary-600 transition-all text-sm font-semibold cursor-pointer whitespace-nowrap self-start mt-2"
          >
            Explorar Guias
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="lg:w-1/2 relative">
          <div className="rounded-[2.5rem] overflow-hidden relative aspect-[3/4]">
            <img
              src="https://readdy.ai/api/search-image?query=Elegant%20overhead%20flatlay%20of%20carefully%20curated%20fashion%20accessories%20including%20leather%20watch%20folded%20scarf%20and%20minimalist%20wallet%20on%20textured%20linen%20fabric%20with%20warm%20golden%20hour%20light%20and%20delicate%20dried%20flower%20accents%2C%20editorial%20lifestyle%20photography%2C%20rich%20caramel%20and%20sand%20tones%2C%20sophisticated%20organic%20composition&width=700&height=900&seq=about-v2-301&orientation=portrait"
              alt="CSSBuy Spreadsheet Coleção 2026"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute top-5 left-5 bg-white px-4 py-2 rounded-full">
              <span className="text-foreground-800 text-xs font-medium whitespace-nowrap">Nova Cole&ccedil;&atilde;o 2026</span>
            </div>
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-6">
              <p className="text-white text-sm font-medium">Produtos selecionados</p>
              <p className="text-white/70 text-xs mt-1">Streetwear &amp; Sneakers</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}